<template>
  <div class="sdg-container">
    <div class="header">EIN SOZIAL GERECHTES WEIDEN</div>
    <div class="separator"></div>
    <div class="content programme-block">

      <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        Teilhabe am gesellschaftlichen Leben in Weiden für alle
        und eine aktive Bürgerbeteiligung sind gewährleistet und für alle
        Generationen ist bestens gesorgt.
        <br>
        Das erreichen wir durch:
      </div>

      <div @click="block1 = !block1" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block1 }"></i>
          Unterstützung von Kindern und Familien
        </div>

        <div v-if="block1">
          Kinder sind unsere Zukunft: Deshalb gehört zu einer
          hochwertigen Ganztagsbetreuung auch ein gutes und ausgewogenes
          Mittagessen, aus bio-regionaler Erzeugung, in der Schulküche frisch
          zubereitet.
          <br>
          <br>

          Wir wollen die Stärkung von Kindern, Jugend und Familien, deshalb fordern wir den
          Ausbau eines generationsübergreifenden Wohnkonzepts für Weiden und
          ortsnahe kostenlose Kinderbetreuung.
          
          <br>
          <br>
          Wir wollen Abenteuerspielplätze für Kinder bauen.

          <br>
          <br>
          Entbürokratisierung der Förderstrukturen für Familien.
          <br>
          <br>
           Treffpunkte für Jugendliche: Das JUZ sollte in alter Frische
           wiederbelebt werden. In allen größeren Stadtteilen soll das Angebot von
           Jugendräumen oder mobiler Betreuung ausgebaut werden. Jugend braucht
           Vielfalt!
        </div>
      </div>

      <div @click="block2 = !block2" class="programme-item">
        <div class="programme-title">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block2 }"></i>
          Chancengleichheit
        </div>
        <div v-if="block2">
          Die Schaffung von Bedingungen und Chancen, die es allen Menschen
          ermöglicht, ihre Fähigkeiten einzubringen und ein gutes und
          selbstbestimmtes Leben in unserer Stadt zu führen.
        </div>
      </div>

      <div @click="block3 = !block3" class="programme-item">
        <div class="programme-title">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block3 }"></i>
          Mitbestimmung
        </div>
        <div v-if="block3">
          Mitbestimmung der Bürger bei kommunalen Projekten, eine
          bürgerfreundliche Verwaltung, den Ausbau von Online-Angeboten, die
          Stärkung und Förderung des ehrenamtlichen Engagements in Sportvereinen,
          Kirchen, Umweltverbänden, beim BRK, der freiwilligen Feuerwehr und vielen
          anderen Initiativen und Vereinen.
          <br><br>
          Bürgerforen und Umweltaktivitäten kleinerer Gruppen aus
          unterschiedlichen Stadtteilen sowie Nachbarschaftsprojekte.
          <br><br>
          Mitspracherecht für Kinder und Jugendliche: Wir wollen die Gründung
          eines Jugendparlaments ermöglichen, um ihren Anliegen mehr Raum zu geben.
        </div>
      </div>

      <div @click="block4 = !block4" class="programme-item">
        <div class="programme-title">
          <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block4 }"></i>
          Urban-Schools
        </div>
        <div v-if="block4">
          Ökologisch orientierte Bildung ist wichtig: Urban City - Urban School:
          In Zusammenarbeit mit dem jeweiligen Bildungsträger, schafft die Stadt
          Angebote zur Bereicherung des vorhandenen Unterrichtsangebotes.  Kinder
          und Jugendliche unterstützen die Stadtgärtnerei bei der Rückgewinnung von
          Blühflächen und übernehmen Patenschaften.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg03',
  data() {
    return {
      block1: false,
      block2: false,
      block3: false,
      block4: false,
    }
  },

}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>
